import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'sketch-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss']
})
export class PillComponent {

  @Input() text: string = ''; 
  @Input() value: any = null;
  @Input() background: string = ''; 
  
  @Output() dismiss = new EventEmitter<any>(); 

  faTimes = faTimes;

  onDismiss( evt: any ){
    evt.preventDefault(); 
    this.dismiss.emit( this.value ); 
  }
}
